var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIndeterminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 14.4,
    height: 14.4,
    rx: 3.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 14.4,
    height: 14.4,
    rx: 3.2,
    stroke: "#002CFB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1454",
    x: 3.5,
    y: 6.5,
    width: 9,
    height: 3,
    rx: 1.5,
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIndeterminate);
export default __webpack_public_path__ + "static/media/checkboxIndeterminate.dd94935f2ab6492e196e297ad98535f6.svg";
export { ForwardRef as ReactComponent };